import { Routes, Route, Navigate } from "react-router-dom";
import ConfirmationGatekeeper from "./ConfirmationGatekeeper";
import ErrorGatekeeper from "./ErrorGatekeeper";
import LandingGatekeeper from "./LandingGatekeeper";
export function AppRoutes() {
    return (
        <Routes>
            <Route path="/404" element={<ErrorGatekeeper />} />
            <Route path="/submit-error" element={<ErrorGatekeeper />} />
            <Route path="/loading-error" element={<ErrorGatekeeper />} />
            <Route path="/retrieval-error" element={<ErrorGatekeeper />} />
            {/* Default */}
            <Route path="/" element={<Navigate replace to="/general" />} />
            

            {/* Enquiry landing */}
            <Route path="/:enquiryFormType/*" element={<LandingGatekeeper />} />

          

            {/* Errors */}
            <Route path="*" element={<Navigate to="/404" replace />} />

            
        </Routes>
    )
}
